import React from "react";

export function WriteSubject({subject,placeholder="Title",autoFocus=false,onChange}) {
    return <div className="">
        <input autoFocus={autoFocus} value={subject} placeholder={placeholder} className="font-medium text-gray-800 text-lg w-full outline-none" onChange={e=>onChange(e.target.value)} />
    </div>
}